/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled from '@emotion/styled';

const StyledSection = styled('section')`
  max-width: 800px;
  display: block;
  margin: 0 auto;
  padding: 40px;

  @media only screen and (min-width: 600px) {
    display: flex;
    padding-bottom: 64px;
  }
`;

const StyledSpan = styled('span')`
  display: block;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 40px;

  @media only screen and (min-width: 600px) {
    padding-bottom: 0;
  }
`;

const StyledDiv = styled('div')`
  padding-left: 0;

  @media only screen and (min-width: 600px) {
    padding-left: 48px;
  }
`;

const StyledH2 = styled.h2`
  font-family: ${({ theme }) => theme.fonts.bold};
  font-size: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.secondary.base};
  margin-top: 0;
  margin-bottom: 16px;
`;

const StyledP = styled('p')`
  color: ${({ theme }) => theme.text.medium};
  font-family: ${({ theme }) => theme.fonts.light};
  margin-bottom: 16px;

  @media only screen and (min-width: 600px) {
    max-width: 480px;
  }
`;

const StyledLink = styled(Link)`
  font-size: 16px;
  font-family: ${({ theme }) => theme.fonts.light};
  border-radius: 24px;
  padding: 10px 24px;
  border: 1.5px solid ${({ theme }) => theme.primary.base};
  color: ${({ theme }) => theme.text.dark};
  background: ${({ theme }) => theme.primary.base};
  font-family: ${({ theme }) => theme.fonts.regular};

  svg {
    padding-left: 8px;
  }
`;

const ProductHeader = ({ action, children, Icon, title }) => (
  <StyledSection>
    <StyledSpan>
      <Icon size={180} />
    </StyledSpan>
    <StyledDiv>
      <StyledH2>{title}</StyledH2>
      <StyledP>{children}</StyledP>
      <StyledLink to={`/get-quote/`}>
        {action}
      </StyledLink>
    </StyledDiv>
  </StyledSection>
);

ProductHeader.propTypes = {
  children: PropTypes.string,
  Icon: PropTypes.func.isRequired,
  action: PropTypes.string,
  productId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

ProductHeader.defaultProps = {
  action: 'Get a quote',
};

export default ProductHeader;
